import React from 'react'
import ResizeDetector from 'react-resize-detector'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import AppMain from '../../core/templates/AppMain'

interface Props extends RouteComponentProps<void> {}

const Main: React.FC<Props> = (props: Props) => {
  return <ResizeDetector handleWidth render={({ width }) => <AppMain />} />
}

export default withRouter(Main)
